import { render, staticRenderFns } from "./Unload.vue?vue&type=template&id=2be8c3c0"
import script from "./Unload.vue?vue&type=script&lang=js"
export * from "./Unload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports